export default {"src":"/_next/static/media/incident-response.47e62417.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};